import React, { useState } from "react";
import { NavLink, Navigate, Outlet, useNavigate } from "react-router-dom";
import {
  MdSpaceDashboard,
  MdOutlineEvent,
  MdOutlineCampaign,
  MdOutlinePhotoLibrary,
  MdOutlineLiveTv,
  MdOutlineSettings,
  MdOutlineGroups,
  MdLogout,
  MdMenu,
  MdClose,
  MdOpenInNew,
} from "react-icons/md";
import useTheme from "../../utils/useTheme";
import styles from "./Dashboard.module.scss";

const navItems = [
  { to: "/dashboard", label: "Overview", icon: <MdSpaceDashboard />, end: true },
  { to: "/dashboard/members", label: "Members", icon: <MdOutlineGroups /> },
  { to: "/dashboard/events", label: "Events", icon: <MdOutlineEvent /> },
  { to: "/dashboard/posts", label: "Announcements", icon: <MdOutlineCampaign /> },
  { to: "/dashboard/gallery", label: "Gallery", icon: <MdOutlinePhotoLibrary /> },
  { to: "/dashboard/live", label: "Live Stream", icon: <MdOutlineLiveTv /> },
  { to: "/dashboard/settings", label: "Site Settings", icon: <MdOutlineSettings /> },
];

const DashboardLayout = () => {
  const { isAdminAuthed, adminLogout } = useTheme();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  if (!isAdminAuthed) {
    return <Navigate to="/dashboard/login" replace />;
  }

  const handleLogout = () => {
    adminLogout();
    navigate("/");
  };

  return (
    <div className={styles.dashboardShell}>
      <aside className={`${styles.sidebar} ${menuOpen ? styles.sidebarOpen : ""}`}>
        <div className={styles.brand}>
          <img src={require("../../assets/logo.jpg")} alt="logo" />
          <div>
            <strong>Samiti Admin</strong>
            <span>Navdurga Utsav</span>
          </div>
          <MdClose className={styles.closeBtn} onClick={() => setMenuOpen(false)} />
        </div>
        <nav>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                isActive ? `${styles.navItem} ${styles.navItemActive}` : styles.navItem
              }
            >
              {item.icon}
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className={styles.sidebarFooter}>
          <button className={styles.viewSiteBtn} onClick={() => navigate("/")}>
            <MdOpenInNew /> View Public Site
          </button>
          <button className={styles.logoutBtn} onClick={handleLogout}>
            <MdLogout /> Logout
          </button>
        </div>
      </aside>
      <div className={styles.dashboardMain}>
        <header className={styles.topbar}>
          <MdMenu className={styles.hamburger} onClick={() => setMenuOpen(true)} />
          <h1>Admin Dashboard</h1>
        </header>
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
